<template>
  <div
    class="flex flex-col justify-center items-center fixed z-50 inset-0 bg-opacity-25 bg-black"
    @click.self="close"
  >
    <div class="form-card relative">
      <button
        class="system-button absolute right-4 top-4"
        @click.prevent="close"
      >
        <close-icon class="w-8 fill-current" />
      </button>

      <form @submit.prevent="loadIntent" class="flex flex-col mt-6">
        <div class="flex flex-col w-full">
          <label for="name">Nombre del Tarjetahabiente</label>
          <input id="name" type="text" v-model="payment.cardholder_name" />
          <validation-errors :errors="errorFor('name')"></validation-errors>
        </div>

        <div class="flex flex-col w-full mt-6">
          <label for="card">Tarjeta</label>
          <div id="card-element"></div>
          <validation-errors :errors="errorFor('card')"></validation-errors>
          <div class="flex mt-1 items-center">
            <safe-icon class="stroke-current text-content-600 w-6" />
            <p class="text-xs text-content-400">
              Tu tarjeta está protegida por Stripe, líder en seguridad de pagos
              en línea.
            </p>
          </div>

          <stripe-icon class="w-12" />
        </div>

        <primary-button class="mx-0 mt-6" :loading="loading"
          >Agregar</primary-button
        >
      </form>
    </div>
  </div>
</template>

<script>
import SafeIcon from "@/icons/SafeIcon";
import StripeIcon from "@/icons/StripeIcon";
import validationErrors from "@/mixins/validationErrors";
import api from "@/api";
import { loadStripe } from "@stripe/stripe-js";
import { stripeKey } from "@/runtimeConfig";
export default {
  name: "Payment Method Modal",

  components: {
    SafeIcon,
    StripeIcon,
  },

  data() {
    return {
      intentToken: null,
      stripe: {},
      cardElement: {},
      payment: {
        cardholder_name: "",
      },
      loading: false,
    };
  },

  mixins: [validationErrors],

  async mounted() {
    this.stripe = await loadStripe(stripeKey);

    const elements = this.stripe.elements({
      fonts: [
        {
          cssSrc:
            "https://fonts.googleapis.com/css2?family=Jost:wght@300;400;500;600;700&display=swap",
        },
      ],
      locale: "es-419",
    });

    this.cardElement = elements.create("card", {
      classes: {
        base: "border py-2 px-3 rounded-lg outline-none smooth w-full focus:shadow-glow bg-white",
      },
      style: {
        base: {
          fontFamily: "Jost",
        },
      },
    });

    this.cardElement.mount("#card-element");
  },

  methods: {
    close() {
      this.$emit("close");
    },

    validateForm() {
      this.errors = {};

      if (!this.payment.cardholder_name) {
        this.errors["name"] = ["Campo requerido."];
      }

      return Object.keys(this.errors).length === 0;
    },

    async loadIntent() {
      if (!this.validateForm()) {
        return;
      }

      this.loading = true;

      try {
        this.intentToken = await api.paymentMethods.getSetupIntent();
        this.addPaymentMethod();
      } catch (error) {
        this.$store.dispatch("errorSnack", this.$t("tryAgain"));
        this.loading = false;
      }
    },

    async addPaymentMethod() {
      this.stripe
        .confirmCardSetup(this.intentToken.client_secret, {
          payment_method: {
            card: this.cardElement,
            billing_details: {
              name: this.cardholder_name,
            },
          },
        })
        .then(
          async function (result) {
            if (result.error) {
              this.$store.dispatch("errorSnack", result.error.message);
              this.loading = false;
            } else {
              this.savePaymentMethod(result.setupIntent.payment_method);
            }
          }.bind(this)
        );
    },

    async savePaymentMethod(payment_method) {
      const request = {
        payment_method: payment_method,
      };

      try {
        const response = await api.paymentMethods.create(request);
        this.$store.dispatch("successSnack", response.message);
        this.$emit("paymentMethodAdded");
      } catch (error) {
        if (error.response.status == 402) {
          this.$store.dispatch("errorSnack", error?.response?.data?.message);
        } else {
          this.$store.dispatch("errorSnack", error?.response?.data?.message);
        }
      }

      this.loading = false;
    },
  },
};
</script>